<template>
  <div class="usersDeatils">
    <div class="accountUsers clearfix">

      <div class="item-modal bind-data bg_fff mt_16" v-loading="isLoading">
        <!-- <div class="item-title"><span class="color_40 f_22">账户安全</span></div> -->

        <div class="item-list flex-c">
          <div class="title f_14 color_40">微信</div>
          <div class="flex1 f_14 clearfix">
            <template v-if="bindData.wechat_is_bound">
              <div class="value-model fl color_40">已绑定</div>
              <div class="color_blue fl cursor_p" @click="unbindAccount('wechat')">解绑</div>
            </template>
            <template v-else>
              <div class="value-model fl color_9c">未绑定</div>
              <div class="color_blue fl cursor_p" @click="getQrcode">绑定</div>
            </template>
          </div>
        </div>
        <div class="item-list flex-c">
          <div class="title f_14 color_40">绑定手机</div>
          <div class="flex1 f_14 clearfix">
            <template v-if="bindData.phone_is_bound">
              <div class="value-model fl color_40">{{bindData.phone}}</div>
              <!-- <div class="color_blue fl cursor_p" @click="unbindAccount('phone')">解绑</div> -->
              <div class="color_blue fl cursor_p" @click="showBindPhone=true">更换手机号</div>
            </template>
            <template v-else>
              <div class="value-model fl color_9c">未绑定</div>
              <div class="color_blue fl cursor_p" @click="showBindPhone=true">绑定</div>
            </template>
          </div>
        </div>
        <!-- <div class="item-list flex-c" v-if="bindData.user.email">
          <div class="title f_14 color_40">绑定邮箱</div>
          <div class="flex1 f_14 clearfix">
            <div class="value-model fl color_40">{{bindData.user.email}}</div>
          </div>
        </div> -->
      </div>

    </div>
    <!-- 绑定手机号弹窗 -->
    <bind-phone v-if="showBindPhone" @bindPhoneSuccess="bindPhoneSuccess" @closeBindPhone="closeBindPhone" />

    <!-- 绑定微信 -->
    <div class="bindQrCode" v-if="showQrCode" @click="hideBindQrcode">
      <div class="tipsContent pa bg_fff text_center" @click.stop>
        <div class="title color_40 f_24">微信绑定 找简历更方便 </div>
        <div class="text f_16 color_9c">人才推荐每天有 优质简历在你手</div>
        <div class="qrCode pr">
          <img :src="qrCodeData.url" alt="" class="qrCodeImg" v-show="qrCodeData.url">
          <img src="https://files.wondercv.com/auth/qrcode_reload.png" alt="" class="qrCodeReload pa cursor_p" @click="getQrcode()" v-if="qrCodeData.checkSize<1">
        </div>
        <div class="text f_16 color_9c">微信扫码 关注超级招聘</div>
      </div>
    </div>

  </div>
</template>

<script>
// 所有接口
import actions from '@/actions/index'
import { mapState, mapMutations } from 'vuex'
import { getCookieValue, get_tUser, toLogin, updateJWT } from '@/utils/utils'
import { uuid } from 'vue-uuid';

//绑定手机号
import BindPhone from '@/components/bindPhone'

export default {
  name: 'user',
  data(){
    return {
      isLoading:true,
      userJWT:{},
      showBindPhone: false, //是否显示绑定手机号弹窗

      bindData:{
        phone: "",
        phone_is_bound: false,
        wechat_is_bound: false
      },
      requestState:false,//接口请求的状态

      showQrCode:false,//是否显示二维码弹窗
      qrCodeQuery:{ // 获取二维码参数
        scene_str:'bind_' + uuid.v1(), //场景值 {扫码业务}+{身份} 扫码业务：login 扫码业务(string):login 例如login_动态的uuid
        account_type:'hr_account', //账户种类 hr_account 或 cv_account
        operation_type:'bind', //是	bind/login 目前只用bind逻辑
        expire_seconds:60, //二维码有效期
      },
      qrCodeData:{ //二维码参数
        url:'',
        checkSize:57/3, // 轮训次数
      },
      qrCodeTimeoutName:null, // 微信登录轮训定时器

    }
  },
  computed:{
    ...mapState('block',['userInfoState']),
    ...mapState('userBindInfo', ['userBindInfo'])
  },
  components:{
    BindPhone
  },
  async created(){
    this.userJWT = get_tUser();
    //获取用户绑定信息
    this.getUsersBind();
  },
  mounted () {
  },
  methods:{
    ...mapMutations('block',['toggleUserInfoState']),
    ...mapMutations('userBindInfo',['setBindInfo']),
    //获取用户绑定信息
    getUsersBind(){
      actions.auth.getUserBind(this.userJWT.t).then(res=>{
        this.isLoading = false;
        if(res.code === 1000){
          this.bindData = res.data;
          this.setBindInfo(this.bindData)
        }
      })
    },
    //解绑
    unbindAccount(type){
      let { phone_is_bound, wechat_is_bound } = this.bindData;
      let bindLength = 0; //绑定的长度
      if(wechat_is_bound){
        bindLength+=1
      }
      if(phone_is_bound){
        bindLength+=1
      }

      //绑定方式小于一种不允许解绑
      if(bindLength<2){
        this.$message.error({message: '唯一登录方式，不可解绑'});
        return false;
      }
      if(type==='wechat'){
        //解绑微信
        this.unbindAccountUser('unbind_wechat');
      }else if(type==='phone'){
        //解绑手机号
        this.unbindAccountUser('unbind_phone');
      }else if(type==='email'){
        this.$message.error({message: '邮箱不支持解绑'});
        return false;
      }
    },
    //解绑微信/手机号
    async unbindAccountUser(operation_type){
      if(this.requestState){
        return false;
      }
      let data = {
        operation_type,
      };
      this.$confirm('确定解绑吗?', '提示', {
        confirmButtonText: '确定',
        confirmButtonClass:'color_blue',
        cancelButtonText: '取消',
        cancelButtonClass:'color_60',
        type: 'warning'
      }).then(() => {
        this.requestState = true;

        actions.auth.updateUserBind(this.userJWT.t, data).then(async res=>{
          this.requestState = false;
          if(res.code === 1000){
            if(operation_type === 'unbind_wechat'){
              this.bindData.wechat_is_bound = false
            }
            this.$message({
              message: `解绑成功`,
              type: 'success'
            });
            this.getUsersBind();
          }else{
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        })
      }).catch(() => {

      });

    },

    //【微信】获取二维码
    getQrcode(){
      //轮训倒计时
      this.qrCodeData.checkSize = 57/3;
      this.showQrCode = true;
      //清除定时器
      clearInterval(this.qrCodeTimeoutName);

      //获取二维码接口
      actions.auth.getWechatsQrcode(this.qrCodeQuery).then(res=>{
        if(res.code === 1000){
          this.qrCodeData.url = res.data.url;
          //轮训倒计时
          this.qrCodeData.checkSize = 57/3;
          // 【微信】检测是否登录
          this.checkWechatLogin();
        }else{
          this.$message.error(res.message);
        }
      })

    },
    //【微信】检测是否扫码
    checkWechatLogin(){
      this.qrCodeTimeoutName = setInterval(() => {
        this.getWechatJwtverify();
        this.qrCodeData.checkSize = this.qrCodeData.checkSize-1;
        if(this.qrCodeData.checkSize<1){
          clearInterval(this.qrCodeTimeoutName);
        }
      }, 3000);
    },
    //【微信】验证是否扫码
    getWechatJwtverify(){
      let query = {
        scene_str: this.qrCodeQuery.scene_str,
        operation_type:'bind',
      }
      actions.auth.getWechatsQrcodeResult(query).then(async res=>{
        if(res.code === 1000){
          this.$message({
            message: '微信绑定成功',
            type: 'success'
          });
          //关闭二维码
          this.hideBindQrcode();
          //重新获取用户绑定信息
          this.getUsersBind();
          //重新设置新的uuid
          this.qrCodeQuery.scene_str = 'bind_' + uuid.v1();
        }else{
          if(res.code === 200101 || res.code === 200203){
            //此微信已经绑定别的账户
            this.$message({
              message: res.message,
              type: 'error'
            });
            //关闭二维码
            this.hideBindQrcode();
            //重新设置新的uuid
            this.qrCodeQuery.scene_str = 'bind_' + uuid.v1();
          }
        }
      })
    },
    //【微信】关闭二维码
    hideBindQrcode(){
      this.showQrCode = false;
      this.qrCodeData = { //二维码参数
        url:'',
        checkSize:57/3, // 轮训次数
      };
      clearInterval(this.qrCodeTimeoutName);
    },

    //手机号绑定成功回调
    bindPhoneSuccess(){
      //重新获取用户绑定信息
      this.getUsersBind();
      this.showBindPhone = false;
    },
    // 关闭绑定手机号
    closeBindPhone(){
      this.showBindPhone = false;
    },

  }
}
</script>
<style lang="scss" scoped>

@import './Index.scss';

</style>
